import { Component, ChangeDetectionStrategy } from "@angular/core";
import { WidgetParent } from "../../class/widget-parent";
import { ComponentAdapterFactory } from "../../class/adapters/component-adapter-factory";
import { SmartPaletteGeneral } from "../../class/smart-palette";
import { LocalDatePipe } from "../../pipes/local-date.pipe";
import { interval, Subscription } from 'rxjs';
import { ComponentAdapterRoom } from "../../class/adapters/component-adapter-room";
import { IonButton, IonIcon } from "@ionic/angular";
import { SmartComponentSpinnerComponent } from "../smart-component-spinner/smart-component-spinner.component";
import { ErrorLoadingWidgetComponent } from "../error-loading-widget/error-loading-widget.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-widget-room",
    templateUrl: "./widget-room.component.html",
    styleUrls: ["./widget-room.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonIcon, SmartComponentSpinnerComponent, ErrorLoadingWidgetComponent, TranslatePipe, LocalDatePipe]
})

export class WidgetRoomComponent extends WidgetParent<ComponentAdapterRoom> {
  private _timeSub: Subscription = null;

  /** Time shown by the clock of the widget, refreshed every minute */
  public now = new Date();

  public isExpanded: boolean = false;
  public isGuestInRoom: boolean = false;

  /**
   * Handle click for opening and closing widget
   */
  public onClickOpenCloseWidget(): void {
    this.isExpanded = !this.isExpanded;
  }

  /**
   * When pointer is down change class for icon
   * @param event
   */
  public onMouseDownStartAnimation(event: Event): void {
    (event.target as HTMLButtonElement).classList.add("active");
  }

  /**
   * When pointer is up start command
   * @param event
   * @param callback command to call in the function
   */
  public onMouseUpStartCommand(event: Event, callback: () => void): void {
    (event.target as HTMLButtonElement).classList.remove("active");
    callback.call(this);
  }

  protected setWidgetSmartPalette(): SmartPaletteGeneral {
    let widgetSmaertPalette = new SmartPaletteGeneral();

    return widgetSmaertPalette;
  }

  protected onComponentLoad(): void {
    //Update date and hour every 60 seconds
    this._timeSub = interval(60000).subscribe(() => {
      this.now = new Date();
    });
  }

  protected onSmartComponentErrorLoading(): void { }

  protected onComponentDestroy(): void {
    this._timeSub?.unsubscribe();
  }

  protected onSmartComponentSuccessLoaded(): void | boolean {
    const factory = new ComponentAdapterFactory();
    this.componentAdapter = factory.createComponentAdapter(
      this._listSmartComponentSkills,
      ComponentAdapterRoom
    );

    this.titleWidget = this.componentAdapter.Name;

    //If component title is empty show error loading component
    if (!this.titleWidget) {
      return this._errorLoading = true;
    }

    this.isExpanded = this._isExpanded;
  }

  protected onAddressValueChange(
    instanceGUID: string,
    address: string,
    value: string
  ): void {
  }
}
